var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrophone = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 65,
  height: 65,
  fill: "none",
  viewBox: "0 0 65 65",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32.353,
  cy: 28.353,
  r: 18.353,
  fill: "#0F8491"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.377,
  d: "M32.354 31.565a3.67 3.67 0 0 0 3.67-3.67v-5.048a3.67 3.67 0 0 0-3.67-3.67 3.67 3.67 0 0 0-3.67 3.67v5.048a3.67 3.67 0 0 0 3.67 3.67"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.377,
  d: "M25.334 26.197v1.56a7.026 7.026 0 0 0 7.02 7.02 7.026 7.026 0 0 0 7.02-7.02v-1.56M31.078 23.242a3.7 3.7 0 0 1 2.551 0M31.62 25.187a2.9 2.9 0 0 1 1.477 0M32.354 34.777v2.753"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 64.163,
  height: 64.163,
  x: 0.272,
  y: 0.194,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.922
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.864
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.227451 0 0 0 0 0.682353 0 0 0 0 0.972549 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_551_26477"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_551_26477",
  result: "shape"
})))));
export { SvgMicrophone as ReactComponent };
export default __webpack_public_path__ + "assets/images/microphone.svg";